
import React, { useEffect,useState,useRef } from 'react';
import {Modal,message,Button,Popover } from 'antd'
import {api_callrecord_list} from '../../api';
import { fieldLabel, formatDisplayValue } from '../../utils/formatDisplayValue';
import { ProTable } from '@ant-design/pro-components';
import Icon,{ UnorderedListOutlined } from '@ant-design/icons';
import StatusColumn from './statuscolumn.jsx';
import Communications from './communications.jsx';

const screenHeight = document.body.clientHeight;
// const screenWidth = document.body.clientWidth;

const CommunicationSvg = () => (
  <svg t="1746861088078" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="19538" width="1.5em" height="1.5em"><path d="M955.733 0H614.4a68.267 68.267 0 0 0-68.267 68.267v204.8a68.267 68.267 0 0 0 68.267 68.266h10.53l-10.393 83.217a17.067 17.067 0 0 0 28.16 14.968l112.264-98.185h200.772A68.267 68.267 0 0 0 1024 273.067v-204.8A68.267 68.267 0 0 0 955.733 0z m34.134 273.067a34.133 34.133 0 0 1-34.134 34.133H748.544a17.067 17.067 0 0 0-11.23 4.215l-83.353 72.91 7.236-57.942a17.067 17.067 0 0 0-16.93-19.183H614.4a34.133 34.133 0 0 1-34.133-34.133v-204.8A34.133 34.133 0 0 1 614.4 34.133h341.333a34.133 34.133 0 0 1 34.134 34.134z" p-id="19539"></path><path d="M665.6 119.467a51.2 51.2 0 1 0 0 102.4 51.2 51.2 0 0 0 0-102.4z m0 68.266a17.067 17.067 0 1 1 0-34.133 17.067 17.067 0 0 1 0 34.133z m119.467-68.266a51.2 51.2 0 1 0 0 102.4 51.2 51.2 0 0 0 0-102.4z m0 68.266a17.067 17.067 0 1 1 0-34.133 17.067 17.067 0 0 1 0 34.133z m119.466-68.266a51.2 51.2 0 1 0 0 102.4 51.2 51.2 0 0 0 0-102.4z m0 68.266a17.067 17.067 0 1 1 0-34.133 17.067 17.067 0 0 1 0 34.133z m51.2 409.6H806.161L693.897 499.15a17.067 17.067 0 0 0-28.16 14.967l10.393 83.217H665.6a68.267 68.267 0 0 0-68.267 68.267v153.6a68.267 68.267 0 0 0 68.267 68.267h290.133A68.267 68.267 0 0 0 1024 819.2V665.6a68.267 68.267 0 0 0-68.267-68.267zM989.867 819.2a34.133 34.133 0 0 1-34.134 34.133H665.6a34.133 34.133 0 0 1-34.133-34.133V665.6a34.133 34.133 0 0 1 34.133-34.133h29.867a17.067 17.067 0 0 0 16.93-19.183l-7.236-57.942 83.319 72.91a17.067 17.067 0 0 0 11.264 4.215h155.99a34.133 34.133 0 0 1 34.133 34.133z m-921.6-221.867h44.783a205.67 205.67 0 0 0 43.298 52.327A272.913 272.913 0 0 0 17.067 887.467V972.8a51.2 51.2 0 0 0 51.2 51.2H512a51.2 51.2 0 0 0 51.2-51.2v-85.333a273.783 273.783 0 0 0-139.196-237.893 205.892 205.892 0 0 0 43.213-52.24H512a68.267 68.267 0 0 0 68.267-68.267V460.8a68.062 68.062 0 0 0-33.502-58.436 272.691 272.691 0 0 0-513.263 0A68.062 68.062 0 0 0 0 460.8v68.267a68.267 68.267 0 0 0 68.267 68.266z m0-34.133a34.133 34.133 0 0 1-34.134-34.133V460.8a34.133 34.133 0 0 1 34.134-34.133H97.28a201.028 201.028 0 0 0 0 136.533z m51.2-68.267a170.667 170.667 0 1 1 333.772 50.176 349.61 349.61 0 0 1-98.286 17.067 51.2 51.2 0 0 0-47.753-33.11h-34.133a51.2 51.2 0 0 0 0 102.4H307.2a51.063 51.063 0 0 0 48.35-35.105 443.733 443.733 0 0 0 78.626-10.24 170.496 170.496 0 0 1-314.71-91.188z m204.8 85.334a17.067 17.067 0 0 1-17.067 17.066h-34.133a17.067 17.067 0 0 1 0-34.133H307.2a17.067 17.067 0 0 1 17.067 17.067zM458.99 718.643a236.68 236.68 0 0 1 70.076 168.824V972.8A17.067 17.067 0 0 1 512 989.867h-85.333v-102.4a17.067 17.067 0 0 0-34.134 0v102.4h-204.8v-102.4a17.067 17.067 0 0 0-34.133 0v102.4H68.267A17.067 17.067 0 0 1 51.2 972.8v-85.333a238.933 238.933 0 0 1 136.311-215.57 203.093 203.093 0 0 0 205.176 0 233.54 233.54 0 0 1 66.304 46.746z m87.142-189.576A34.133 34.133 0 0 1 512 563.2h-29.013a201.028 201.028 0 0 0 0-136.533H512a34.133 34.133 0 0 1 34.133 34.133zM290.133 256a238.353 238.353 0 0 1 215.62 136.533h-38.536a204.322 204.322 0 0 0-354.167 0H74.513A238.353 238.353 0 0 1 290.133 256z" p-id="19540"></path><path d="M682.667 716.8h51.2a17.067 17.067 0 0 0 0-34.133h-51.2a17.067 17.067 0 0 0 0 34.133z m256-34.133H802.133a17.067 17.067 0 0 0 0 34.133h136.534a17.067 17.067 0 0 0 0-34.133z m0 85.333h-51.2a17.067 17.067 0 0 0 0 34.133h51.2a17.067 17.067 0 0 0 0-34.133zM819.2 768H682.667a17.067 17.067 0 0 0 0 34.133H819.2a17.067 17.067 0 0 0 0-34.133z" p-id="19541"></path></svg>
  // <svg t="1746860848706" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16681" width="1.2em" height="1.2em"><path d="M1000.36892 913.555269l-97.370984 97.768882c-10.458997 10.458997-295.694024 78.726686-630.836655-257.666476C-65.993995 414.251866 2.785276 128.675785 13.187431 118.216788L110.615258 20.447907A68.381375 68.381375 0 0 1 207.417819 19.822641l143.98173 193.434595c21.997998 32.741207 26.318019 70.143488-0.625266 97.200457L291.146634 370.25587c11.595844 105.044705 53.374988 165.866044 112.377371 225.095796 66.732946 66.903473 129.543768 133.977473 250.33381 134.943793l57.638166-57.808693c26.886442-27.000127 64.175039-22.680107 96.859404-0.625266l192.638801 144.550154c32.286468 22.28221 26.261176 70.086646-0.625266 97.143615zM921.07381 512.418644h-158.988117c-18.701141 0-33.991739-16.200076-33.991739-36.094907 0-19.894831 15.290598-36.094907 33.991739-36.094906h158.988117c18.757983 0 34.048581 16.200076 34.048582 36.094906 0 19.894831-15.290598 36.094907-34.048582 36.094907z m0-168.423951h-249.708544c-18.871668 0-34.105424-16.200076-34.105424-36.038064 0-20.008515 15.233756-36.151749 34.105424-36.151749h249.708544c18.757983 0 34.048581 16.143234 34.048582 36.151749 0 19.837988-15.290598 36.038064-34.048582 36.038064z m0-168.423951h-340.542656c-18.814825 0-34.048581-16.143234-34.048581-36.151749 0-19.894831 15.233756-36.038064 34.048581-36.038064h340.542656c18.757983 0 34.048581 16.143234 34.048582 36.038064 0 20.008515-15.290598 36.151749-34.048582 36.151749z" fill="#666666" p-id="16682"></path></svg>
      );
const CommunicationIcon = props => (
    <Icon component={CommunicationSvg} {...props} />
    );

const CallDropSvg = () => (
  <svg t="1746860444149" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15650" width="1.5em" height="1.5em"><path d="M638.208 351.18c14.131 0 25.6-11.468 25.6-25.6V107.52c0-14.131-11.469-25.6-25.6-25.6s-25.6 11.469-25.6 25.6v218.06c0 14.132 11.469 25.6 25.6 25.6z m143.36 0c14.131 0 25.6-11.468 25.6-25.6V107.52c0-14.131-11.469-25.6-25.6-25.6s-25.6 11.469-25.6 25.6v218.06c0 14.132 11.469 25.6 25.6 25.6zM510.976 696.32c0-30.515 5.478-59.75 15.514-86.784-2.253 0.051-4.608-0.051-7.015-0.205-40.499-1.331-85.913-30.157-131.328-83.251-69.478-81.254-72.909-124.826-68.761-143.565 3.993-18.278 17.715-24.883 17.817-24.934a25.605 25.605 0 0 0 14.592-15.616c2.407-7.015 1.536-14.746-2.253-21.146l-115.404-192c-6.759-11.213-20.839-15.616-32.82-10.445-5.785 2.51-142.438 62.516-157.44 157.799-14.95 94.822 59.239 240.998 198.605 391.168 157.389 169.677 287.693 219.648 369.203 231.68 1.024 0.153 2.048 0.205 3.072 0.358-62.822-45.67-103.782-119.654-103.782-203.059z" p-id="15651"></path><path d="M761.856 476.16c-86.835 0-161.894 50.278-197.734 123.29a219.418 219.418 0 0 0-22.426 96.87 219.208 219.208 0 0 0 26.573 104.96c3.379 6.246 7.065 12.288 11.008 18.176a221.773 221.773 0 0 0 68.403 65.229c33.28 20.224 72.346 31.897 114.176 31.897 121.6 0 220.16-98.56 220.16-220.16 0-121.65-98.56-220.262-220.16-220.262z m117.146 311.142a20.521 20.521 0 0 1 0 28.98c-3.994 3.993-9.216 5.99-14.49 5.99s-10.496-1.997-14.49-5.99l-87.91-87.91-87.91 87.91c-3.994 3.993-9.216 5.99-14.49 5.99s-10.496-1.997-14.49-5.99a20.521 20.521 0 0 1 0-28.98l87.91-87.91-87.91-87.91a20.521 20.521 0 0 1 0-28.98 20.521 20.521 0 0 1 28.98 0l87.91 87.91 87.91-87.91a20.521 20.521 0 0 1 28.98 0 20.521 20.521 0 0 1 0 28.98l-87.91 87.91 87.91 87.91z" p-id="15652"></path></svg>
      );
const CallDropIcon = props => (
    <Icon component={CallDropSvg} {...props} />
    );
  

const App = (props) => {
    const {showModal, rowInfo, closeModal, invitationStatusEnum} = props;
    // console.log('-------invitationStatusEnum----------- ', invitationStatusEnum)
    const actionRef = useRef();

    const [tableData, setTableData] = useState([]);
    const [statusEnum, setStatusEnum] = useState({});

    const CallDrop = ({messages}) => {
      console.log('messages - ', messages)
      return (
          <div style={{ width: '400px',  padding: '16px', margin: '0 auto', }}>
              {Object.keys(messages).map(key=>(
                <p key={key} style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{fieldLabel(key)}：{formatDisplayValue(messages[key])}</p>
              ))}
          </div>
      );
    };

    const columns = [
        {
          title: '外呼时间',
          dataIndex: 'call_time',
          key: 'call_time',
          width: 150,
        },
        {
          title: '邀约状态',
          dataIndex: 'invitation_status',
          key: 'invitation_status',
          valueType: 'select',
          valueEnum: statusEnum,
          width: 200,
          render: (_, record) => <StatusColumn record={record} valueEnum={statusEnum} islink={false} />
        },
        {
          title: '沟通记录',
          dataIndex: 'communication_record',
          key: 'communication_record',
          search: false,
          ellipsis: true,
          render: (_, record) => {
            // console.log('messages 00- ',record, typeof record.communication_record)
            let messages=[];
            try {
              var obj = JSON.parse(record.communication_record.replace(/\n/g,"\\n").replace(/\r/g,"\\r"));
              // console.log('=======messages=========',obj)
              // console.log('=======messages=========',typeof(obj))
              if (obj && typeof obj === "object") 
                  messages = obj;
            } catch (e) {
              console.log('=======messages e=========',e)
              
            }
            return messages.length>0 ? 
            <Popover content={<Communications messages={messages} />} title="沟通记录">
              <CommunicationIcon />
            </Popover>:""
            }
        },
        {
          title: '通话中断详情',
          dataIndex: 'call_drop_scenario_details',
          key: 'call_drop_scenario_details',
          search: false,
          ellipsis: true,
          render: (_, record) => {
            let messages={};
            try {
              var obj = JSON.parse(record.call_drop_scenario_details);
              if (obj && typeof obj === "object") 
                  messages = obj;
            } catch (e) {
            }
            return Object.keys(messages).length>0 ? 
            <Popover content={<CallDrop messages={messages} />} title="通话中断详情">
              <CallDropIcon />
            </Popover>:""
            }
        },
      ];

    useEffect(() => {
        if(showModal && rowInfo.candidate_id)
          actionRef.current?.reload();
            // setTableData(JSON.parse(rowInfo.client_list));
        // else
        //     setTableData([]);
      }, [showModal, rowInfo]);
  
    return (
        <Modal 
            key="scoredetail"
            title={'候选人 '+rowInfo.name+' 外呼记录'}
            open={showModal}
            width={"60%"}
            bodyStyle={{height:screenHeight*0.5,overflowY:"scroll"}}
            centered
            maskClosable={false}
            footer={[<Button  className="m-btn-white" onClick={closeModal}>
            关闭
            </Button>,] }
            onCancel={closeModal}>

          <ProTable
            // headerTitle="候选人列表"
            columns={columns}
            actionRef={actionRef}
            rowKey="id"
            cardBordered
            defaultSize="small"
            request={async (params, sort, filter) => {
              console.log(params,sort, filter);
              // await waitTime(2000);
              var tableData = [];
              var res = await api_callrecord_list({candidate_id:rowInfo.candidate_id});
              console.log('api_callrecord_list-res-----------------', res);
              if(res.data.code == 9){
                tableData = res.data.list;
                setStatusEnum(res.data.status);
              }else
                message.error(res.data.msg);

              return {
                data: tableData,
                // current: res.data.pageNo,
                // pageSize: res.data.pageSize,
                success: true,
                // total: res.data.totalRows,
              };
            }}
            search={false}
            options={{
              reload: false, // 去掉刷新按钮
              density: false, // 去掉密度按钮
              setting: true, // 保留列设置按钮
              setting: {
                listsHeight: 400,
              },
            }}
            style={{lineHeight: '0.40rem',marginTop:'0.32rem',overflowX: 'auto',overflowY: 'auto'}}  
            scroll={{x:600}}
            columnsState={{
              persistenceKey: 'pro-table-callrecord',
              persistenceType: 'localStorage',
              onChange(value) {
                console.log('value: ', value);
              },
            }}

            // form={{
            //   // 由于配置了 transform，提交的参与与定义的不同这里需要转化一下
            //   syncToUrl: (values, type) => {
            //     if (type === 'get') {
            //       return {
            //         ...values,
            //         created_at: [values.startTime, values.endTime],
            //       };
            //     }
            //     return values;
            //   },
            // }}
            pagination={false}
            // dateFormatter="string"

            toolBarRender={() => []}
          />


        </Modal>
    )
}

export default App